import { render, staticRenderFns } from "./UpdateDateNotificationDialog.vue?vue&type=template&id=70721b62&scoped=true"
import script from "./UpdateDateNotificationDialog.vue?vue&type=script&lang=js"
export * from "./UpdateDateNotificationDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateDateNotificationDialog.vue?vue&type=style&index=0&id=70721b62&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70721b62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70721b62')) {
      api.createRecord('70721b62', component.options)
    } else {
      api.reload('70721b62', component.options)
    }
    module.hot.accept("./UpdateDateNotificationDialog.vue?vue&type=template&id=70721b62&scoped=true", function () {
      api.rerender('70721b62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/notification/UpdateDateNotificationDialog.vue"
export default component.exports